module.exports = __webpack_public_path__ + "img/public/siteImages/googleVerify.svg?d820e6b2";